// =============================================================================
// Child PDP — JS for pdp-cushions-and-throws / pdp-standard-linen
// Loaded from sections/main-product.liquid
// =============================================================================

// -----------------------------------------------------------------------------
// Product Group Swatches — desktop/mobile truncation
// (was inline in snippets/product-group-swatches.liquid)
// -----------------------------------------------------------------------------
function initProductGroupSwatches(root) {
  root = root || document;
  const mobileContainer = root.querySelector('.swatches-mobile .swatches-grid');
  if (!mobileContainer || mobileContainer.dataset.swatchesInit) return;
  mobileContainer.dataset.swatchesInit = '1';

  const mobileSwatches = Array.from(
    mobileContainer.querySelectorAll('.swatch-wrapper:not(.swatch-wrapper-selected)')
  );
  const showMoreButton = root.querySelector('.show-more-swatches');

  const desktopContainer = root.querySelector('.swatches-desktop .swatches-grid');
  const desktopShowMore = root.querySelector('.show-more-swatches-desktop');
  if (desktopContainer && desktopShowMore) {
    const desktopSwatches = Array.from(desktopContainer.querySelectorAll('.desktop-swatch'));
    if (desktopSwatches.length > 9) {
      const desktopRemaining = desktopSwatches.length - 9;
      desktopSwatches.forEach((el, i) => {
        if (i >= 9) el.style.display = 'none';
      });
      desktopShowMore.textContent = `View +${desktopRemaining}`;
      desktopShowMore.style.display = '';
      let desktopExpanded = false;
      desktopShowMore.addEventListener('click', () => {
        desktopExpanded = !desktopExpanded;
        desktopSwatches.forEach((el, i) => {
          if (i >= 9) el.style.display = desktopExpanded ? '' : 'none';
        });
        desktopShowMore.textContent = desktopExpanded ? 'Show less' : `View +${desktopRemaining}`;
      });
    }
  }

  if (showMoreButton && mobileSwatches.length > 7) {
    const remainingCount = mobileSwatches.length - 7;

    showMoreButton.textContent = `+ View ${remainingCount}`;
    showMoreButton.setAttribute('title', `+ Show ${remainingCount} colours`);
    showMoreButton.setAttribute('aria-label', `+ Show ${remainingCount} colours`);
    showMoreButton.classList.add('visible');

    mobileSwatches.forEach((swatch, index) => {
      if (index >= 7) {
        swatch.closest('a').style.display = 'none';
      }
    });

    let isExpanded = false;
    showMoreButton.addEventListener('click', () => {
      isExpanded = !isExpanded;
      mobileSwatches.forEach((swatch, index) => {
        const link = swatch.closest('a');
        if (index >= 7) {
          link.style.display = isExpanded ? '' : 'none';
        }
      });
      if (isExpanded) {
        showMoreButton.textContent = '- Show less';
        showMoreButton.setAttribute('title', '- Show less colours');
        showMoreButton.setAttribute('aria-label', '- Show less colours');
      } else {
        showMoreButton.textContent = `+ View ${remainingCount}`;
        showMoreButton.setAttribute('title', `+ Show ${remainingCount} colours`);
        showMoreButton.setAttribute('aria-label', `+ Show ${remainingCount} colours`);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductGroupSwatches());
} else {
  initProductGroupSwatches();
}

// -----------------------------------------------------------------------------
// Variant Picker Swatches — view more button
// (was inline in snippets/product-variant-picker-swatch.liquid)
// -----------------------------------------------------------------------------
function initVariantSwatchViewMore(root) {
  root = root || document;
  root.querySelectorAll('.swatch-view-more-btn').forEach(btn => {
    if (btn.dataset.swatchViewMoreInit) return;
    btn.dataset.swatchViewMoreInit = '1';
    btn.addEventListener('click', () => {
      const ul = btn.closest('ul');
      ul.querySelectorAll('.swatch-hidden, .mobile-swatch-hidden').forEach(li => {
        li.classList.remove('swatch-hidden', 'mobile-swatch-hidden');
      });
      btn.closest('.swatch-view-more-item').style.display = 'none';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initVariantSwatchViewMore());
} else {
  initVariantSwatchViewMore();
}

// -----------------------------------------------------------------------------
// Trustpilot app-widget suppression
// Hides the Trustpilot Shopify app's auto-injected widget when our own
// [data-tp-anchor] widget is present (previously handled by product-details.liquid)
// -----------------------------------------------------------------------------
(() => {
  const scrollToReviews = () => {
    const accordion = document.querySelector('[data-reviews-accordion]');
    if (!accordion) return;
    if (!accordion.open) accordion.open = true;
    requestAnimationFrame(() => {
      const headerHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')
      ) || 0;
      const top = accordion.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  };

  document.querySelectorAll('.product__rating').forEach(el => {
    el.style.cursor = 'pointer';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.addEventListener('click', scrollToReviews);
    el.addEventListener('keydown', ({ key }) => {
      if (key === 'Enter' || key === ' ') scrollToReviews();
    });
  });

  const addOverlay = wrapper => {
    if (wrapper.querySelector('.tp-anchor-overlay')) return;
    wrapper.style.position = 'relative';
    const overlay = document.createElement('button');
    overlay.className = 'tp-anchor-overlay';
    overlay.type = 'button';
    overlay.setAttribute('aria-label', 'View product reviews');
    overlay.style.cssText = 'position:absolute;inset:0;z-index:1001;background:transparent;border:none;cursor:pointer;';
    wrapper.appendChild(overlay);
    overlay.addEventListener('click', scrollToReviews);
  };

  const ourWidget = document.querySelector('[data-tp-anchor]');

  if (ourWidget) {
    const hideAppWidgets = () => {
      document.querySelectorAll('[id^="trustpilot-widget-trustbox-"][id$="-wrapper"]').forEach(w => { w.style.display = 'none'; });
    };
    hideAppWidgets();
    const hideObs = new MutationObserver(() => {
      hideAppWidgets();
      if (document.querySelector('[id^="trustpilot-widget-trustbox-"][id$="-wrapper"]')) hideObs.disconnect();
    });
    hideObs.observe(document.body, { childList: true, subtree: true });

    if (ourWidget.querySelector('iframe')) {
      addOverlay(ourWidget);
    } else {
      new MutationObserver((_, obs) => {
        if (ourWidget.querySelector('iframe')) { addOverlay(ourWidget); obs.disconnect(); }
      }).observe(ourWidget, { childList: true });
    }
  } else {
    const attachToAppWidget = () => {
      document.querySelectorAll('[id^="trustpilot-widget-trustbox-"][id$="-wrapper"]').forEach(addOverlay);
    };
    attachToAppWidget();
    const obs = new MutationObserver(() => {
      attachToAppWidget();
      if (document.querySelector('[id^="trustpilot-widget-trustbox-"][id$="-wrapper"]')) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();

// -----------------------------------------------------------------------------
// Quick shop modal — re-init swatches when quick view content is loaded
// -----------------------------------------------------------------------------
document.addEventListener('quickview:loaded', () => {
  const modal = document.querySelector('.quick-view__content');
  if (!modal) return;
  initProductGroupSwatches(modal);
  initVariantSwatchViewMore(modal);
});
